import React from "react";
import { useTranslation } from "react-i18next";

export default function NetworkStatsPanel({ statistics }) {
  const { t } = useTranslation();
  
  const storagePercent = statistics.storageMax 
    ? Math.round((statistics.storageUsed / statistics.storageMax) * 100) 
    : 0;
  
  return (
    <div className="network-stats-panel">
      <h3>
        <span className="icon">📊</span>
        {t('network.stats.title', 'Network Statistics')}
      </h3>
      
      <div className="stat-row">
        <span className="stat-label">{t('network.stats.totalFiles', 'Total Files')}</span>
        <span className="stat-value highlight">{statistics.totalUsers.toLocaleString()}</span>
      </div>
      
      <div className="stat-row">
        <span className="stat-label">{t('network.stats.metaFiles', 'Meta Files')}</span>
        <span className="stat-value">{(statistics.totalMetaFiles || 0).toLocaleString()}</span>
      </div>
      
      <div className="stat-row">
        <span className="stat-label">{t('network.stats.activeConnections', 'Network Connections')}</span>
        <span className="stat-value">{statistics.activeConnections.toLocaleString()}</span>
      </div>
      
      <div className="stat-row">
        <span className="stat-label">{t('network.stats.dataPoints', 'Data Points')}</span>
        <span className="stat-value">{statistics.dataPointsShared.toLocaleString()}</span>
      </div>
      
      <div className="stat-row">
        <span className="stat-label">{t('network.stats.storage', 'Storage')}</span>
        <span className="stat-value">{statistics.storageUsed || 0} / {statistics.storageMax || 500} GB</span>
      </div>
      
      <div className="stat-row">
        <span className="stat-label">{t('network.stats.weeklyGrowth', 'Weekly Growth')}</span>
        <span className="stat-value positive">+{statistics.weeklyGrowth}%</span>
      </div>
      
      <div className="stat-row">
        <span className="stat-label">{t('network.stats.matchRate', 'Match Rate')}</span>
        <span className="stat-value">{statistics.matchRate}%</span>
      </div>
      
      <div className="category-bars">
        <div className="section-title">Category Distribution</div>
        {statistics.topCategories.map((cat, idx) => (
          <div className="category-bar" key={idx}>
            <div className="bar-header">
              <span className="bar-label">{cat.name}</span>
              <span className="bar-value">{cat.count ? cat.count.toLocaleString() : cat.percentage + '%'}</span>
            </div>
            <div className="bar-track">
              <div 
                className="bar-fill" 
                style={{ 
                  width: `${cat.percentage}%`,
                  background: `linear-gradient(90deg, ${cat.color}, ${cat.color}88)`
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
